export type ModalBackdropProps = {
  onClick: () => void
}

export const ModalBackdrop = ({ onClick }: ModalBackdropProps) => {
  return (
    <button
      type="button"
      tabIndex={-1}
      onClick={onClick}
      className="absolute inset-0 hidden size-full cursor-default bg-black/30 sm:block"
    />
  )
}
